const CookieConsent = require("./CookieConsent");

jQuery(document).ready(function () {
  if (window.$madSettings && window.$madSettings.cookieConsent) {
    const cookieConsent = new CookieConsent(window.$madSettings.cookieConsent);

    // Attach CookieConsent instance to the global window object
    window.CookieConsent = cookieConsent;
  }
});